export enum EventCategory {
  Coupon = 'coupon',
  Lp = 'lp',
}
